import { render, staticRenderFns } from "./EditingDFElement.vue?vue&type=template&id=36acc971&"
import script from "./EditingDFElement.vue?vue&type=script&lang=js&"
export * from "./EditingDFElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports